import { Input } from "@/components/podkit/forms/Input";
import { InputField } from "@/components/podkit/forms/InputField";
import type { FC } from "react";

type ServiceAccountFormFieldsProps = {
    name: string;
    description: string;
    onNameChange: (value: string) => void;
    onDescriptionChange: (value: string) => void;
    autoFocus?: boolean;
};

export const ServiceAccountFormFields: FC<ServiceAccountFormFieldsProps> = ({
    name,
    description,
    onNameChange,
    onDescriptionChange,
    autoFocus = false,
}) => {
    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
                <InputField label="Name">
                    <Input
                        id="service-account-name"
                        data-testid="service-account-name-input"
                        name="name"
                        value={name}
                        onChange={(e) => onNameChange(e.target.value)}
                        placeholder="Example: ci-runner-bot, staging-deployer, github-sync"
                        autoFocus={autoFocus}
                        required
                        minLength={1}
                        maxLength={64}
                        data-1p-ignore
                        data-lpignore
                        data-protonpass-ignore
                    />
                </InputField>
            </div>
            <div className="flex flex-col gap-2">
                <InputField label="Description">
                    <Input
                        id="service-account-description"
                        data-testid="service-account-description-input"
                        name="description"
                        value={description}
                        onChange={(e) => onDescriptionChange(e.target.value)}
                        placeholder="Optional: Describe this account's purpose for other admins."
                        maxLength={500}
                    />
                </InputField>
            </div>
        </div>
    );
};
